import React from 'react';
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { BrujoProvider } from './Context/BrujoContext';
import { AppRouter } from './router/AppRouter';
import 'bootstrap/dist/css/bootstrap.css';
import './theme/index.scss';
import 'animate.css';

const AppState = ({children}) => {
  return (
    <BrujoProvider>
      {children}
    </BrujoProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppState>
        <AppRouter />
      </AppState>
    </BrowserRouter>
  </React.StrictMode>
)

serviceWorkerRegistration.unregister();
reportWebVitals();
